module.exports = __webpack_public_path__ + "static/media/JSIcon.390d331c.png";